<template>
  <div class="modal-drag-custom-drag limit-height-size allow-click" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			:resizable="false"
			height="auto"
			width="90%"
			:maxWidth="900"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center justify-center">
							<v-icon color="white" small class="info-icon mr-2">mdi-briefcase-plus-outline</v-icon>
							<p class="mb-0 font-weight-bold text-primary title">Detalle Anexo Contrato</p>
						</div>
						<v-btn class="mx-2" fab dark small color="#FF1209" @click="closeModal">
							<v-icon dark>mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
        <v-card-text class="pa-4">
					<NonEditableContract :contract_id="$store.state.contracts.contractAddendumModalId" v-if="isClient"/>
					<ClientContract :contract_id="$store.state.contracts.contractAddendumModalId" v-else/>
				</v-card-text>
			</v-card>
		</modal>
	</div>
</template>

<script>
import NonEditableContract from '@/components/Views/Contracts/NonEditableContract'
import ClientContract from '@/components/Views/Clients/Parts/Contracts/ClientContract'

export default {
	name: 'ClientsContractModal',
  components: { NonEditableContract, ClientContract },
  data() {
    return {
			indexModal: + new Date(),
    };
  },
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		isClient(){
			return this.$checkPermissions(['client_capabilities'])
		},
		contract(){
			return this.$store.state.contracts.contractAddendumModalInfo
		},
		contractAddendums(){
			return this.contract?.addendums || []
		},
  },
	watch:{
		contract(newValue){
			console.log('Contract: ', newValue)
			if(newValue){
				this.$store.commit('contracts/setContractAddendumModalInfo', this.contract)
			}
		}
	},
	mounted(){
		this.$modal.show('custom_drag_modal')
			this.$store.commit('general/addOpenModalOrders', this.indexModal)
	},
	beforeDestroy(){
		this.$store.commit('contracts/setContractAddendumModalId', false)
	},
  methods: {
    closeModal(){
			this.$store.commit('contracts/setContractAddendumModalId', false)
    }
  },
};
</script>

<style scoped>
	.client-items-container{
		border: 1px solid rgb(213, 211, 211);
	}
	.single-message{
		background-color: rgb(217, 239, 217);
		border: 1px solid rgb(197, 232, 197);
		padding: 4px 8px;
		max-width: 80%;
		border-radius: 10px;
		font-size: 14px;
		margin-bottom: 8px;
		text-transform: none;
	}
	.single-message.assistant{
		background-color: rgb(213, 211, 211);
		border: 1px solid rgb(193, 191, 191);
		align-self: flex-end;
	}
	.template-list-item:hover{
		background-color: rgba(0,0,0,0.2);
	}
	.menu-bg-white{background: white;}
	.vertical-tabs .rotated-tab {
		writing-mode: vertical-lr;
		transform: rotate(180deg);
		text-align: center;
		height: 150px;
		line-height: 1;
	}

	.vertical-tabs .v-tab {
		justify-content: center;
		align-items: center;
		min-height: 100px;
		padding: 0px;
		min-width: 40px;
		width: 40px;
		font-size: 12px;
	}
	.vertical-tabs {
		align-items: flex-start;
		height: 100%;
	}
	.custom-color-tabs .v-tab{
		font-size: 12px;
	}
	.custom-color-tabs .v-tab.v-tab--active {
		background-color: #FF120B;
		color: #FFFFFF;
	}
	.custom-color-tabs .v-tab:not(.v-tab--active) {
		background-color: white;
		color: #000000!important;
	}
	.change-col-size{
		position: absolute;
		top: 0;
		left: 0;
		z-index: 9;
	}
	/* .allow-click .vm--container{
		pointer-events: none;
	}
	/deep/.allow-click .vm--container .vm--modal{
		pointer-events: all!important;
	} */
</style>
<style>
	.crm-conversation .single-message p{
		margin-bottom: 0;
	}
	.tab-item-custom .v-window__container{height: auto;}
</style>